import { Link } from "react-router-dom";

// Official HEARD mark: sage squircle badge with white "H" + speech-bubble dot
export const LogoMark = ({ size = 64, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
    <rect x="4" y="4" width="92" height="92" rx="28" fill="#8CA084" />
    <path d="M34 27 V73 M66 27 V73 M34 50 H66" stroke="#FDFCF8" strokeWidth="10.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M62 60c0-3.9 4.1-7 9-7s9 3.1 9 7-4.1 7-9 7c-1 0-2-.1-2.9-.4L64 68l1.6-3.4c-2.2-1.2-3.6-3.1-3.6-4.6Z" fill="#8CA084" stroke="#FDFCF8" strokeWidth="4" strokeLinejoin="round" />
  </svg>
);

export const Logo = ({ tagline = false, tone = "default", active = false, compact = false, onClick, className = "" }) => {
  const word = tone === "cream" ? "#FDFCF8" : "#6C8759";
  const tag = tone === "cream" ? "rgba(253,252,248,0.65)" : "#6C8759";
  const underline = tone === "cream" ? "rgba(253,252,248,0.7)" : "#8CA084";
  const gapCls = compact ? "gap-3 lg:gap-5" : "gap-5";
  const markCls = compact ? "h-11 w-11 lg:h-16 lg:w-16" : "h-16 w-16";
  const wordCls = compact ? "text-[1.95rem] lg:text-[2.7rem]" : "text-[2.7rem]";
  return (
    <Link to="/" onClick={onClick} className={`inline-flex items-center ${gapCls} group shrink-0 ${className}`} data-testid="brand-logo">
      <LogoMark size={64} className={`${markCls} transition-transform duration-500 group-hover:scale-105 shrink-0`} />
      <span className="flex flex-col leading-none">
        <span className="relative inline-block w-fit">
          <span className={`font-serif italic ${wordCls} font-medium tracking-normal`} style={{ color: word }}>Heard</span>
          <span
            className="absolute -bottom-1 left-0 h-px rounded-full transition-all duration-700 ease-out"
            style={{ width: active ? "100%" : "0%", backgroundColor: underline, opacity: active ? 0.9 : 0 }}
            aria-hidden="true"
          />
        </span>
        {tagline && (
          <span className="text-[0.66rem] uppercase tracking-[0.28em] mt-1.5" style={{ color: tag }}>
            Community · Empathy · Hope
          </span>
        )}
      </span>
    </Link>
  );
};
